import React from 'react'
import pgaLogoSrc from '../../../../assets/images/pga-logo-jobs-modal.png'
import {
  StyledModalWithBack,
  StyledLogoWrapper,
  StyledLogoImg,
  StyledTitle,
  StyledInfo,
  StyledButton,
  StyledButtonLink
} from './styles'

export default ({ isOpen, toggle }) => (
  <StyledModalWithBack isOpen={isOpen} toggle={toggle}>
    <button className='close' onClick={toggle}>&times;</button>
    <StyledLogoWrapper>
      <StyledLogoImg src={pgaLogoSrc} />
    </StyledLogoWrapper>
    <StyledTitle>Login to you account</StyledTitle>
    <StyledInfo>
        If you have an existing PGA.org account please login to proceed.
    </StyledInfo>
    <StyledButtonLink to={{ pathname: '/login', state: { page: '/' } }}>
      <StyledButton>Login</StyledButton>
    </StyledButtonLink>
  </StyledModalWithBack>
)
